(ns common.endpoints.ai-enrichment
  "Shared Malli :in/:out models for the AI entity-enrichment endpoints
   (backend.domain.ai.enrich.endpoints). Request schemas describe the RPC :body;
   responses are wrapped in {:body ...}.")

(def max-open-jobs
  "How many unresolved jobs an account's process list shows. Old jobs the user
   never dealt with drop off the end instead of growing the list forever."
  50)

(def ok-response
  [:map
   [:body any?]])

(def enrich-field-spec
  "An explicitly-described advertised field, for contexts whose fields are not
   plain entity-schema attributes (e.g. survey questions): the key the model
   answers under, a human label, optional choice options, and the data type
   the answer is stored as."
  [:map
   [:key keyword?]
   [:label {:optional true} string?]
   [:mandatory? {:optional true} boolean?]
   [:data-type {:optional true} keyword?]
   [:options {:optional true} [:sequential [:map [:value any?] [:label string?]]]]])

(def enrich-target
  "One entity in a config-driven flow. Fields come from EITHER :fields (entity-
   schema attribute keys, shaped against the schema) OR :field-specs (fully
   described inline). :slug/:label are optional overrides."
  [:map
   [:entity-type keyword?]
   [:fields {:optional true} [:sequential keyword?]]
   [:field-specs {:optional true} [:sequential enrich-field-spec]]
   [:slug {:optional true} string?]
   [:label {:optional true} string?]])

(def request-enrichment
  "Start an enrichment job from a create flow. Context is EITHER a transaction-
   process template (:template-kw) OR a config-driven target set (:targets, one
   per entity in the flow). :entity-type is the root entity being created; :draft
   is the partial create data and :rule-context the vehicle-derived rule keys,
   both feeding field resolution; :attachment-ids are the dropped documents."
  [:map
   [:template-kw {:optional true} keyword?]
   [:entity-type {:optional true} keyword?]
   [:targets {:optional true} [:sequential enrich-target]]
   [:draft {:optional true} [:maybe map?]]
   [:rule-context {:optional true} [:maybe map?]]
   [:attachment-ids [:sequential int?]]])

(def result-request
  [:map
   [:result-id int?]])

(def list-request
  "List the requesting account's unresolved enrichment jobs."
  [:map])

(def resolve-request
  "Mark a job resolved once its result was saved or discarded."
  [:map
   [:result-id int?]])

(def create-target-request
  "Create the entity a job's result is applied to: `:entity` is the create
   flow's entity data, as :entity/create-entity takes it."
  [:map
   [:result-id int?]
   [:entity [:map [:entity/type keyword?]]]])
